<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? `Editing ${item.make} ${item.model} (${item.vrn})` : 'Create New Vehicle'" subtitle="Provide the main details of the Vehicle in this section." class="py-8 border-b">
                <ui-input-file preview :current="editMode ? item.image : null" label="Image" name="image" :error="form.errors.get('image')" v-model="form.image"></ui-input-file>
                <ui-input label="Make" name="make" :error="form.errors.get('make')" v-model="form.make" class="xl:col-span-6"></ui-input>
                <ui-input label="Model" name="model" :error="form.errors.get('model')" v-model="form.model" class="xl:col-span-6"></ui-input>
                <ui-input label="Registration" name="vrn" :error="form.errors.get('vrn')" v-model="form.vrn" class="xl:col-span-6"></ui-input>
                <ui-input label="Reference" name="reference" :error="form.errors.get('reference')" v-model="form.reference" class="xl:col-span-6"></ui-input>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Ownership" subtitle="Define the legal terms for that vehicles." class="py-8 border-b">
                <ui-radio label="Ownership Type" name="ownership" v-model="form.ownership" :options="ownershipTypes" :error="form.errors.get('ownership')" class="xl:col-start-1 xl:col-end-7"></ui-radio>
                <template v-if="form.ownership === 'leased'">
                    <ui-date-picker label="Lease Commence" name="lease_commence" :error="form.errors.get('lease_commence')" v-model="form.lease_commence" placeholder="When does the lease commence..."></ui-date-picker>
                    <ui-select-searchable
                        label="Lease Company"
                        v-model="form.lease_company"
                        :error="form.errors.get('lease_company_id')"
                        :search="searchCompanies"
                    ></ui-select-searchable>
                    <ui-input label="Lease Advance Payment" name="lease_advance_payment" :error="form.errors.get('lease_advance_payment')" v-model="form.lease_advance_payment"></ui-input>
                    <ui-select-searchable
                        class="xl:col-span-6"
                        label="Lease Payment Frequency"
                        v-model="form.lease_freq"
                        :error="form.errors.get('lease_followed_by_frequency')"
                        :options="leasePaymentFrequencies"
                    ></ui-select-searchable>
                    <ui-input
                        class="xl:col-span-6"
                        :label="`Lease ${form.lease_freq ? form.lease_freq.label : ''} Payment Amount`"    
                        name="lease_followed_by_value" 
                        :error="form.errors.get('lease_followed_by_value')" 
                        v-model="form.lease_followed_by_value"
                    ></ui-input>
                    <ui-input label="How Many Payments?" name="lease_followed_by_number" :error="form.errors.get('lease_followed_by_number')" v-model="form.lease_followed_by_number" class="xl:col-span-6"></ui-input>
                    <ui-input label="Lease Final Payment" name="lease_final_payment" :error="form.errors.get('lease_final_payment')" v-model="form.lease_final_payment" class="xl:col-span-6"></ui-input>
                </template>
                <template v-if="form.ownership === 'owned'">
                    <ui-input label="Purchase Price" name="purchase_price" :error="form.errors.get('purchase_price')" v-model="form.purchase_price" class="xl:col-span-6"></ui-input>
                </template>
                <template v-if="form.ownership === 'sold'">
                    <ui-date-picker label="Sold At" name="sold_at" :error="form.errors.get('sold_at')" v-model="form.sold_at" placeholder="When was the vehicle sold..." class="xl:col-span-6"></ui-date-picker>
                </template>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Important Dates" class="py-8 border-b">
                <ui-date-picker label="MOT Due" name="mot_due" :error="form.errors.get('mot_due')" v-model="form.mot_due" placeholder="When is the MOT due..." class="xl:col-span-6"></ui-date-picker>
                <ui-date-picker label="Service Due" name="service_due" :error="form.errors.get('service_due')" v-model="form.service_due" placeholder="When is the service due..." class="xl:col-span-6"></ui-date-picker>
                <ui-date-picker label="Road Tax Due" name="road_tax_due" :error="form.errors.get('road_tax_due')" v-model="form.road_tax_due" placeholder="When is the road tax due..." class="xl:col-span-6"></ui-date-picker>
                <ui-date-picker label="Purchase Date" name="purchase_date" :error="form.errors.get('purchase_date')" v-model="form.purchase_date" placeholder="When was the purchase date..." class="xl:col-span-6"></ui-date-picker>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Extra Attributes" class="py-8 border-b">
                <ui-toggle label="Fleet Insurance" text="Does this vehicle has fleet insurance?" name="fleet_insurance" :error="form.errors.get('fleet_insurance')" v-model="form.fleet_insurance" class="xl:col-span-6"></ui-toggle>
                <ui-toggle label="CC Account" text="Does this vehicle has a CC account?" name="cc_account" :error="form.errors.get('cc_account')" v-model="form.cc_account" class="xl:col-span-6"></ui-toggle>
                <ui-toggle label="CC Autopay" text="Does this vehicle has CC autopay?" name="cc_autopay" :error="form.errors.get('cc_autopay')" v-model="form.cc_autopay" class="xl:col-span-6"></ui-toggle>
                <ui-toggle label="Parking Account" text="Does this vehicle has a parking account?" name="parking_account" :error="form.errors.get('parking_account')" v-model="form.parking_account" class="xl:col-span-6"></ui-toggle>
                <ui-toggle label="Dart Charge" text="Does this vehicle has dart charges?" name="dart_charge" :error="form.errors.get('dart_charge')" v-model="form.dart_charge" class="xl:col-span-6"></ui-toggle>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Driver and Mileage" class="py-8 border-b">
                <ui-select-searchable
                    label="Driver"
                    v-model="form.driver"
                    :error="form.errors.get('driver_id')"
                    :search="searchContact"
                ></ui-select-searchable>
                <ui-toggle label="Requires Mileage" text="Does this vehicle requires mileage?" name="milage_required" :error="form.errors.get('milage_required')" v-model="form.milage_required" class="xl:col-span-6"></ui-toggle>
                <template v-if="form.milage_required">
                    <ui-radio label="Mileage Requirement Frequency" name="milage_frequency" v-model="form.milage_frequency" :options="mileageFrequencies" :error="form.errors.get('milage_frequency')" class="xl:col-span-6"></ui-radio>
                </template>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { Vehicle, Company, Contact } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : { ownership: 'leased' }

        return {
            ownershipTypes: [
                { value: 'leased', label: 'Leased' },
                { value: 'owned', label: 'Owned' },
                { value: 'sold', label: 'Sold' },
            ],
            leasePaymentFrequencies: [
                { value: 'daily', label: 'Daily'},
                { value: 'weekly', label: 'Weekly'},
                { value: 'monthly', label: 'Monthly'},
                { value: 'quarterly', label: 'Quarterly'},
                { value: 'yearly', label: 'Yearly'},
            ],
            mileageFrequencies: [
                { value: 'daily', label: 'Daily'},
                { value: 'weekly', label: 'Weekly'},
                { value: 'monthly', label: 'Monthly'},
                { value: 'quarterly', label: 'Quarterly'},
            ],
            form: new Form(initialData, async (form) => {
                try {
                    if (this.editMode) {
                        await this.item.update(form.export())
                        this.edit(false)
                    } else {
                        const vehicle = await Vehicle.create(form.export())
                        this.addItem(vehicle, 0)

                        form.reset()
                    }
                } catch (error) {

                    throw error
                }
            }),
        }
    },
    methods: {
        async searchCompanies (query) {
            return (await Company.search(query)).map(x => x.toDropdown())
        },
        async searchContact (query) {
            return (await Contact.search(query)).map(x => x.toDropdown())
        },
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
